import { ModelBase } from 'store/model-base';

export class CmsBillingPayment extends ModelBase {
    public static storeName: string = 'cmsBillingPayment';

    public total: string;
    public accountNumber: string;
    public pastDueReminder: string;
    public transactionDisplayNames: CmsTransactionDisplayNameMapping[];
    public paidTransactionLink: string;
    public caret: CmsMediaImage;
    public states: CmsBillingPaymentState[];
    public bill: string;
}
